import React, {useState, useEffect, useMemo, useRef} from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import Tooltip from '@material-ui/core/Tooltip';

import { useTable, useExpanded } from "react-table";

import '../../styles/style.scss';

import GroupsService from "../../services/groups.service";
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { useDispatch, useSelector } from 'react-redux';
import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { ADMINISTRADOR } from '../../constants/models/typeOperationRol';

export const GroupsScreen = (props) => {

  const { isLoggedIn, user } = useSelector( state => state.auth);
  const noCustomer = isLoggedIn? user.noCustomer:'';
  const operationRol = isLoggedIn? user.operationRol:'---';

  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const [groups, setGroups] = useState([]);
  const groupsRef = useRef();

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [errorResponse, setErrorResponse] = useState('');
  const [isErrorResponse, setIsErrorResponse] = useState(false);

  groupsRef.current = groups;

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Nombre",
        accessor: "nameGroup"
      },
      {
        Header: 'Representante',
        accessor: 'manager.name'
      },
      {
        Header: "Estado",
        accessor: "status",
      },
      {
        Header: "Acciones",
        accessor: "actions",
        Cell: (propsCells) => {

          const rowIdx = propsCells.row.id;

          const editGroup = (rowIndex) => {
            const id = groupsRef.current[rowIndex].id;
            props.history.push(`/administration/groups/update/${id}`);
            window.location.reload();
          };

          return (
            <div>
              {
                validateAccessUser(view.CREATE_GROUP, user) &&
              <button className="btn custom-btn-icons" onClick={() => editGroup(rowIdx)}>
                <i className="far fa-edit action mr-2"></i>
              </button>
              }
            </div>
          );
        },
      }
    ],// eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: groups,
  },
  useExpanded);

  const getGroups = () => {
    setGroups([]);
    setIsLoadingData(true);
    GroupsService.getAllGroupsByCustomer(noCustomer)
      .then((response) => {
        setIsLoadingData(false);
        setGroups(response);
      })
      .catch((error) => {
        console.log(error)
        setIsLoadingData(false);
        setGroups([]);
        setIsErrorResponse(true);
        if(error.response){
          setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          }
        } else{
          setErrorResponse(error);
          actionErrorConnection(error);
        }
      });
  };

  useEffect(() =>{
    getGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNewRol = () => {
    props.history.push('/administration/groups/create');
    window.location.reload();
  }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />
                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Groups</span>
                    </div>
                  
                    <div className="col-12 pt-3 pb-3 ps-1 pe-1">
                        <div className="row ">
                            <div className="container p-0">
                              <div className="row m-0">
                                <div className="col-12">
                                <div className={`w-100 d-flex justify-content-end
                                ${validateAccessUser(view.CREATE_GROUP, user) && operationRol === ADMINISTRADOR ? 'd-inline' : 'd-none'}`}>
                                  <Tooltip title="Nuevo grupo" placement="top-start" arrow>
                                    <button className="btn custom-btn-icons" 
                                    type="button" 
                                    onClick={getNewRol}>
                                      <i className="fas fa-plus-square custom-icon-add"></i>
                                    </button>
                                  </Tooltip>
                                </div>
                        
                                   <table
                                    {...getTableProps()}
                                  >
                                    <thead>
                                      {headerGroups.map((headerGroupGroups, i) => (
                                        <tr {...headerGroupGroups.getHeaderGroupProps()} className="border-content " key={i}>
                                          {headerGroupGroups.headers.map((column,j) => (
                                            <th {...column.getHeaderProps()}
                                            className="border-element header-element header-text pt-3 pb-3" key={j}>
                                              {column.render("Header")}
                                            </th>
                                          ))}
                                        </tr>
                                      ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                      {rows.map((rowGroups) => {
                                        prepareRow(rowGroups);
                                        return (
                                          <React.Fragment key={rowGroups.getRowProps().key}>
                                          <tr className="element-row border-content">
                                            {rowGroups.cells.map((cell,i) => {
                                              return (
                                                <td className="border-element content-text pt-2 pb-2"
                                                {...cell.getCellProps()}
                                                key={i}>
                                                  {
                                                    cell.column.id === 'status' ? 
                                                    (cell.value ? 'Activo' : 'inactivo')
                                                    : cell.render("Cell")
                                                  }
                                                </td>
                                              );
                                            })}
                                          </tr>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                  {(isErrorResponse) &&
                                    <div className="error-message border-content pt-4 pb-4">
                                      <span className="">{errorResponse?.toString()}</span>
                                    </div>}
                                  {(isLoadingData) &&
                                    <div className="element-row border-content pt-4 pb-4 custom-icon-loading">
                                      <i className="fas fa-spinner fa-spin"></i>
                                    </div>}
                                    {(groups.length === 0 && !isLoadingData && !isErrorResponse) &&
                                      <div className="element-row-message border-content pt-4 pb-4 ">
                                        <span>No se recuperaron coincidencias.</span>
                                      </div>
                                    }
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}

GroupsScreen.propTypes = {
  row: PropTypes.any,
  getToggleAllRowsSelectedProps : PropTypes.any,
  history: PropTypes.object
};